module.exports = __webpack_public_path__ + "img/detail-header-bg.604086a7.png";